import script from "./AdminHealthSafetyManageFormOptionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminHealthSafetyManageFormOptionsView.vue?vue&type=script&setup=true&lang=js"

import "./AdminHealthSafetyManageFormOptionsView.vue?vue&type=style&index=0&id=bdae0c9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdae0c9c"]])

export default __exports__